// Google Analytics 4 + Google Ads event tracking
// Uses the gtag.js snippet already loaded in public/index.html
// (configured with G-ZTGETFQ6ZZ for GA4 and G-E66TDY32NZ for Google Ads).
// Any event fired via window.gtag is automatically delivered to both
// destinations, so the same call is available as a Google Ads conversion
// once you enable it in the Google Ads dashboard (Tools → Conversions →
// import from Google Analytics).

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }
  window.gtag('event', eventName, params);
};

// Virtual pageview for SPA funnel steps: updates the browser URL (no reload)
// and sends a page_view to GA4 + Google Ads, so these URLs can be used as
// page-based conversions in Google Ads campaigns.
export const trackVirtualPage = (path) => {
  if (typeof window === 'undefined') return;
  if (window.location.pathname !== path) {
    window.history.replaceState({}, '', path);
  }
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.origin + path,
      page_title: document.title,
    });
  }
};
